import { useEffect, useState } from "react";
import axios from "axios";
import { BACKEND_URL } from "@/lib/backendUrl";

export const API = `${BACKEND_URL}/api`;
export const P = `${API}/purchases`;
export const fmt = (n) => `S$${Number(n || 0).toLocaleString("en-SG", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const d = (s) => (s ? new Date(`${s}T00:00:00`).toLocaleDateString("en-SG", { day: "2-digit", month: "short", year: "numeric" }) : "—");
export const today = () => new Date().toISOString().slice(0, 10);
export const DOC_TYPES = { supplier_invoice: "Supplier Invoice", receipt: "Receipt", purchase_bill: "Purchase Bill", credit_note: "Credit Note", debit_note: "Debit Note", other: "Other" };
export const PAY_METHODS = { bank_transfer: "Bank Transfer", cash: "Cash", paynow: "PayNow", credit_card: "Credit Card", debit_card: "Debit Card", other: "Other" };
export const STATUS = { unpaid: "bg-amber-500/15 text-amber-300", partially_paid: "bg-sky-500/15 text-sky-300", paid: "bg-emerald-500/15 text-emerald-300" };
export const catLabel = (c) => (c ? `${c.parent_category} → ${c.name}` : "—");
export const inp = "h-10 bg-slate-950/60 border-slate-700 text-sm";
export const sel = "h-10 w-full rounded-md border border-slate-700 bg-slate-950/60 px-3 text-sm text-slate-100";

export function useCategories() {
  const [cats, setCats] = useState([]);
  useEffect(() => { axios.get(`${P}/categories`).then(({ data }) => setCats(data)).catch(() => {}); }, []);
  return cats;
}

export function useSuppliers() {
  const [sups, setSups] = useState([]);
  const load = () => axios.get(`${P}/suppliers`).then(({ data }) => setSups(data)).catch(() => {});
  useEffect(() => { load(); }, []);
  return [sups, load];
}

// Private documents: fetch as blob (cookie/Bearer auth), never expose storage URLs
export async function documentBlobUrl(docId, download = false) {
  const { data } = await axios.get(`${P}/documents/${docId}`, { params: download ? { download: 1 } : {}, responseType: "blob" });
  return URL.createObjectURL(data);
}
